module.exports = __webpack_public_path__ + "static/media/illustration.4f1f8ab7.png";